import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_ROUTINE_TAB_ANCHOR } from '../anchors';

export const dashboardRoutineTabHint: Hint = {
  id: asHintId('dashboard:routine-tab'),
  version: 2,
  priority: 65,
  anchor: DASHBOARD_ROUTINE_TAB_ANCHOR,
  copy: {
    title: 'Routine — within 48 hours',
    body: 'Routine patients should typically be addressed within 48 hours. Click this tab to focus your queue on routine work.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
